import { FeatureToggleOfflineService } from './feature-toggle-offline.service';

export const offlineServices = [FeatureToggleOfflineService];
